import { Roles, RolesAllResponse } from "app/types/configuracion/roles";
import { toaster } from "app/utilities/commons";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_NET;

export async function getAllRoles(page: number | string, pageSize: number | string, code?: string, description?: string) {
    let response;
    try {
        response = await axios.get<RolesAllResponse>(`${API_URL}Roles?Page=${page}&PageSize=${pageSize}`);
        return response.data.data;
    } catch (err) {
        console.error("Error fetching Roles");
        throw err;
    }
}

export async function getAllRolesFilter(page: number | string, pageSize: number | string, code?: string, description?: string) {
    let response;
    try {
        response = await axios.get<RolesAllResponse>(`${API_URL}Roles?Code=${code}&Page=${page}&PageSize=${pageSize}`);
        console.log("CODIGO FILTER ", response.data.data);
        return response.data.data;
    } catch (err) {
        console.error("Error fetching Roles");
        throw err;
    }
}

export async function getAllRolesFilterDesc(page: number | string, pageSize: number | string, description?: string) {
    let response;
    try {
        response = await axios.get<RolesAllResponse>(`${API_URL}Roles?Description=${description}&Page=${page}&PageSize=${pageSize}`);
        console.log("DESCRIPTION FILTER", response.data.data);
        return response.data.data;
    } catch (err) {
        console.error("Error fetching Roles");
        throw err;
    }
}

export async function roleCreateAndUpdate(body: Roles) {
    let response;
    const { code, description, status, id } = body;
    if (id) {
        try {
            response = await axios.put(`${API_URL}Roles/${id}`, {
                code,
                description,
                status,
                id
            });
            toaster.success('Se cambio con éxito la información');
            return response.data;
        } catch (err) {
            console.error('Error UPDATING role', err);
            throw err;
        }
    } else {
        try {
            response = await axios.post(`${API_URL}Roles`, {
                code,
                description,
                status
            })
            toaster.success("Guardado correctamente");
            return response.data;
        } catch (err) {
            console.error('Error CREATING role', err);
            throw err;
        }
    }
}